<template>
<div>
  <Header />
  <LoadingDialog
    ref="LoadingDialog"
    message="Please stand by..."
    specific
  />
  <v-container grid-list-md fluid class="container-style">
    <div class="container-header">
      <span>Student List</span>
    </div>
    <v-layout row wrap>
      <v-flex>
        <div class="elevation-1">
          <v-toolbar flat color="white">
            <v-layout row wrap justify-end>
              <v-flex xs12 md4 class="box-white">
                <v-text-field
                  color="#091D3B"
                  v-model="search"
                  prepend-inner-icon="search"
                  label="Search"
                  box
                  style="padding-top: 2px;"
                >
                </v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 md4 class="box-white">
                <v-autocomplete
                  v-model="selectedSchoolYear"
                  :items="schoolYears"
                  item-text="name"
                  item-value="id"
                  return-object
                  @change="filterBySchoolYear"
                  color="#091D3B"
                  prepend-inner-icon="date_range"
                  label="School Year"
                  box
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-layout row wrap class="mt-1">
              <v-flex xs12 md6>
                <div v-if="statistics.total_students">
                <span><strong>Total Student: </strong>{{statistics.total_students.total}} |</span>
                <span class="px-1"><strong>Pre-School: </strong>{{statistics.total_students.departments.pre_school.total}} |</span>
                <span class="px-1"><strong>Grade School: </strong>{{statistics.total_students.departments.grade_school.total}} |</span>
                <span class="px-1"><strong>Jr. High School: </strong>{{statistics.total_students.departments.jr_high_school.total}} |</span>
                <span class="px-1"><strong>Sr. High School: </strong>{{statistics.total_students.departments.sr_high_school.total}}</span>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn @click="clickExportStudents" outline color="#091D3B">
                Export
              </v-btn>
              <v-btn @click="addStudent" class="button-style-blue">
                Add Student
                <v-icon dark right>add</v-icon>
              </v-btn>
            </v-layout>
          </v-toolbar>
        <!-- <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-btn outline color="#091D3B">
            <v-icon>file_copy</v-icon>
          </v-btn>
          <v-btn outline color="#091D3B">
            <v-icon>local_printshop</v-icon>
          </v-btn>
        </v-toolbar> -->
          <v-data-table
            v-model="studentTable"
            :headers="headers"
            :items="students"
            :search="search"
            :pagination.sync="pagination"
            item-key="student.full_name"
          >
            <template v-slot:items="props">
              <tr :active="props.studentTable" @click="props.studentTable = !props.studentTable">
                <td v-if="props.item.student_number_display">
                  {{ props.item.student_number_display }}
                </td>
                <td class="text-xs-left" v-else>
                  <v-btn small class="button-style-blue">Enroll</v-btn>
                </td>
                <td>
                  {{ props.item.first_name }}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" v-if="props.item.admin_notes" color="red darken-4" size="15px">warning</v-icon>
                    </template>
                    <span>{{props.item.admin_notes}}</span>
                  </v-tooltip>
                </td>
                <td>{{ props.item.last_name }}</td>
                <td>{{ props.item.middle_name }}</td>
                <td>{{ props.item.birthday }}</td>
                <td v-if="props.item.selected_enrollment_data">
                  {{ props.item.selected_enrollment_data.payment_plan_display }}
                </td>
                <td v-else></td>
                <td v-if="props.item.selected_enrollment_data">
                  {{ currencyFormat(props.item.selected_enrollment_data.remaining_balance) }}
                </td>
                <td v-else></td>
                <td>
                  <router-link :to="{name: 'student-detail', params: {id: props.item.id}}" style="text-decoration: none!important;">
                    <v-btn
                      color="light-gray"
                      :icon="true"
                    >
                      <v-icon
                        color="green darken-4"
                        size="15px"
                      >
                        mdi-eye
                      </v-icon>
                    </v-btn>
                  </router-link>
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card flat>
                <v-card-text>Peek-a-boo!</v-card-text>
              </v-card>
            </template>
          </v-data-table>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn @click="addStudent" class="button-style-blue">
              Add Student
              <v-icon dark right>add</v-icon>
            </v-btn>
          </v-toolbar>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script type="text/javascript">
import Header from '@/components/Header.vue'

import {
  mapState,
  mapActions
} from 'vuex';

import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  components: {
    Header,
    LoadingDialog,
  },
  computed: {
    ...mapState(['students', 'schoolYears', 'statistics']),
  },
  data() {
    return {
      search: '',
      pagination: {
        rowsPerPage: 25,
        sortBy: 'student_number_display'
      },
      selectedSchoolYear: '',
      studentTable: [],
      ordering: 'last_name',
      filters: {
        all_students: false,
        department: false,
        level: false,
      },
      headers: [
        {
          text: 'Student Number',
          value: 'student_number_display',
          width: '10%'
        },
        {
          text: 'First Name',
          value: 'first_name',
          width: '20%'
        },
        {
          text: 'Last Name',
          value: 'last_name',
          width: '20%'
        },
        {
          text: 'Middle Name',
          value: 'middle_name',
          width: '15%'
        },
        {
          text: 'Birthday',
          value: 'birthday',
          width: '10%'
        },
        {
          text: 'Payment Plan',
          value: 'selected_enrollment_data.payment_plan_display',
          width: '10%'
        },
        {
          text: 'Balance',
          value: 'selected_enrollment_data.remaining_balance',
          width: '10%'
        },
        {
          text: '',
          sortable: false,
          width: '5%'
        }
      ],
    }
  },
  methods: {
    ...mapActions(['getStudents', 'getSchoolYears', 'getStudentsWithUnenrolled', 'getOverallStatistics']),
    currencyFormat (balance) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      return formatter.format(balance)
    },
    clickExportStudents () {
      window.open('/api/student/generate-students-excel/?filter_data=' + this.selectedSchoolYear.id)
    },
    getActiveSchoolYear() {
      this.schoolYears.some((schoolYear) => {
        if (schoolYear.is_open) {
          this.selectedSchoolYear = schoolYear;
          return true
        }
      })
    },
    filterBySchoolYear() {
      let self = this
      this.$refs.LoadingDialog.dialog = true
      this.getStudentsWithUnenrolled({
          schoolYear: this.selectedSchoolYear
        })
        .then(() => {
          this.$refs.LoadingDialog.dialog = false
        })
        .catch((errors) => {
          this.$refs.LoadingDialog.dialog = false
          self.$toastr('error', errors, 'Error');
        })
    },
    addStudent() {
      this.$router.push({
        name: 'student-form'
      });
    }
  },
  mounted () {
    this.$refs.LoadingDialog.dialog = true
    this.getSchoolYears()
      .then((data) => {
        this.getActiveSchoolYear() // <-- this is synchronous
        this.getStudentsWithUnenrolled({schoolYear: this.selectedSchoolYear})
          .then(() => {
            this.$refs.LoadingDialog.dialog = false
          })
        this.getOverallStatistics(this.selectedSchoolYear)

      })
  },
}
</script>
